module.exports = __webpack_public_path__ + "static/media/Barclays.907610f3.png";